import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {AddOrUpdateRoleOptions} from "./options/add-or-update-role.options";
import {MatDialogRef} from "@angular/material/dialog";
import {DataResponse} from "../../../../network/service/data.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";

@Component({
  selector: 'app-add-or-update-role',
  standalone: false,
  templateUrl: './add-or-update-role.component.html',
  styleUrls: ['./add-or-update-role.component.scss']
})
export class AddOrUpdateRoleComponent extends BaseComponent implements OnInit {
  addOrUpdateRoleOptions = new AddOrUpdateRoleOptions();
  title?: string;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateRoleComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateRoleOptions.role.Title;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    (this.addOrUpdateRoleOptions.role.RoleId !== undefined ? this.serviceApi.updateRoles(this.addOrUpdateRoleOptions.role.RoleId, {
      Title: this.title,
      BusinessId: this.addOrUpdateRoleOptions.businessId
    }) : this.serviceApi.createRoles({
      Title: this.title,
      BusinessId: this.addOrUpdateRoleOptions.businessId
    })).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.addOrUpdateRoleOptions.onInsertOrUpdateFinished();
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
